import { StandardEvents } from '@shopify/events';

class BoundlessCoasterOptions extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const section = this.closest('.shopify-section');
    if (!this.#holderSelect) return;
    this.dataset.ready = '';
    this.addEventListener('change', this.#change, { signal: this.#controller.signal });
    section?.addEventListener(StandardEvents.productSelect, this.#sync, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  get #holderSelect() {
    return this.closest('.shopify-section')?.querySelector(
      'variant-picker[data-product-id="15849387098278"] select[name="options[Holder]"]'
    );
  }

  #change = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const arrangement = this.querySelector('[data-holder-arrangement]');
    const color = this.querySelector('[data-holder-color]');
    const holder = this.#holderSelect;
    if (!(arrangement instanceof HTMLSelectElement) || !(color instanceof HTMLSelectElement) || !(holder instanceof HTMLSelectElement)) return;
    const value = arrangement.value + ' / ' + color.value;
    if (![...holder.options].some((option) => option.value === value) || holder.value === value) return;
    holder.value = value;
    holder.dispatchEvent(new Event('change', { bubbles: true }));
  };

  #sync = (event) => {
    if (!(event.target instanceof HTMLElement) || event.target.dataset.productId !== this.dataset.productId) return;
    event.promise.then(({ detail }) => {
      const updated = detail?.html?.querySelector('boundless-coaster-options');
      if (!updated) return;
      for (const selector of ['[data-holder-arrangement]', '[data-holder-color]']) {
        const current = this.querySelector(selector);
        const next = updated.querySelector(selector);
        if (current instanceof HTMLSelectElement && next instanceof HTMLSelectElement) current.value = next.value;
      }
      const currentNote = this.querySelector('[data-photo-note]');
      const nextNote = updated.querySelector('[data-photo-note]');
      if (currentNote && nextNote) {
        currentNote.textContent = nextNote.textContent;
        currentNote.hidden = nextNote.hidden;
      }
    }).catch(() => {});
  };
}

if (!customElements.get('boundless-coaster-options')) {
  customElements.define('boundless-coaster-options', BoundlessCoasterOptions);
}
